import { styles } from './template.scss';
import { styles as commonStyles } from '../../assets/common.scss';

export const templateAlertsDetailsPanel = document.createElement('template');

templateAlertsDetailsPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  
    <div id="alertDetailsPanel">
       <gz-title id="alertDetailsPanelTitle" fontWeight='500' fontSize='16'></gz-title>     
       <div id="sections"></div>
       <div id="general-actions"></div>
    </div>
`;
